export const DATASET_LABELS = {
  Contact: 'Family Office',
  FoundationContact: 'E&F',
  RiaContact: 'RIA',
  BtContact: 'B&T',
};

export const datasetLabel = (dataset) => DATASET_LABELS[dataset] || dataset;